module.exports = __webpack_public_path__ + "static/media/MoveIt_Low_Impact_Dance_Fitness_3.408f9bbd.webp";